import { SET_GLOBAL_DROPDOWN, RESET } from '../actions';

const initialState = {  
  addressType: [],
  productType: [],
  userType: []
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_GLOBAL_DROPDOWN:
      console.log(action);
      return {
        ...state,
        ...action.data
      };
    case RESET :
      return initialState
    default:
      return state;
  } 
}
